// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2rMqG","right":"styles_right__3SF1U"};